<div class="bg-gradient-to-r from-blue-400 via-blue-500 to-purple-600 text-white rounded-md mx-6 mt-4 shadow-lg overflow-hidden transition-all duration-500 px-2">
  <div class="flex justify-between items-center p-4">
        <div>
        <h2 class="text-lg md:text-xl lg:text-2xl font-bold"> 
            <span *ngIf="selectedMachineName">{{ selectedMachineName }}</span>
            Machine Daily Production Overview
        </h2>

        <div class="flex flex-col md:flex-row md:items-center md:space-x-4 mt-1 text-sm space-y-2 md:space-y-0">
            <span class="flex items-center space-x-1">
                <i class="far fa-calendar-alt"></i>
                <span>{{ getSelectedDepartmentName() }}</span>
            </span>
            <span class="flex items-center space-x-1">
                <i class="far fa-calendar-alt"></i>
                <span>{{ today }}</span>
            </span>
            <span class="flex items-center space-x-1">
                <i class="far fa-clock"></i>
                <span>{{ currentTime }}</span>
            </span>
        </div>

        </div>

        <div class="flex items-center gap-6">
        <div class="text-right">
            <p class="font-bold">Live Dashboard</p>
            <p class="text-xs">Auto-refresh every 60 minutes</p>
        </div>

        <button 
            class="p-2 rounded-full bg-white/20 hover:bg-white/30 transition"
            (click)="showFilters = !showFilters"
            >
            <svg xmlns="http://www.w3.org/2000/svg" 
                fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" 
                class="w-6 h-6 text-white">
            <path stroke-linecap="round" stroke-linejoin="round" 
                    d="M3 4h18M6 12h12M10 20h4"/>
            </svg>
        </button>
        </div>
    </div>
    <div *ngIf="showFilters" class="px-4 pb-4">
        <div class="flex flex-wrap justify-center items-center gap-4">
            <select id="department" [ngModel]="departmentId()" 
                    class="px-3 py-2 rounded-md bg-white/10 border border-white/20 text-gray-900 text-sm focus:outline-none focus:ring-2 focus:ring-white/40"
                    (ngModelChange)="onDepartmentChange($event)">
                @for (dept of $$departmentDTO(); track dept.departmentId) {
                <option [ngValue]="dept.departmentId">{{ dept.departmentName | titlecase }}</option>
                }
            </select>

            <select id="machine" class="px-3 py-2 rounded-md bg-white/10 border border-white/20 text-gray-900 text-sm focus:outline-none focus:ring-2 focus:ring-white/40"
                    [(ngModel)]="machineId" (ngModelChange)="onMachineChange($event)">
                <option [ngValue]="null" hidden disabled selected>Choose a Machine</option>
                @for (machine of $$availableMachines(); track machine) {
                <option [ngValue]="machine.machineId">{{ machine.machineName | titlecase }}</option>
                }
            </select>
            <input 
                type="date" 
                [max]="today" 
                [value]="selectedDate()"
                (change)="onDateChange($event)"
                class="px-3 py-2 rounded-md bg-white/10 border border-white/20 text-gray-900 text-sm focus:outline-none focus:ring-2 focus:ring-white/40">
        </div>
    </div>
</div>
<div>
  <div class="mx-6 mt-4 grid grid-col md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-7 gap-4 md:gap-4">
    <div class="bg-gradient-to-br from-blue-200 to-blue-400 rounded-lg shadow-lg w-full flex flex-col items-start p-4 h-32">
        <div class="flex justify-between w-full">
            <p class="text-4xl font-bold text-black">{{ $$ImpressionDTO()[0].plannedImpressions | number }} <span class="text-xl">{{ $$ImpressionDTO()[0].unitOfMachine }}</span></p>
        </div>
        <p class="text-sm text-blue font-semibold">Planned Count</p>
    </div>
    <div class="bg-gradient-to-br from-green-200 to-green-400 rounded-lg shadow-lg w-full flex flex-col items-start p-4 h-32">
        <div class="flex justify-between w-full">
            <p class="text-4xl font-bold text-black">{{ selectedMachineShiftOutputSum | number }} <span class="text-xl">{{ $$ImpressionDTO()[0].unitOfMachine }}</span></p>
        </div>
        <p class="text-sm text-blue font-semibold">Output Count</p>
    <div class="w-full bg-gray-300 rounded-full h-2 mt-2">
        <div 
            class="bg-green-500 h-2 rounded-full transition-all duration-500" 
            [style.width.%]="completePercentage > 100 ? 100 : completePercentage">
        </div>
    </div>
    <p class="text-base font-bold text-green-500 mt-1">
        {{ completePercentage }}%
    </p>
    </div>

    <div class="bg-white rounded-lg shadow-lg w-full flex flex-col items-start p-4 h-32">
        <div class="flex justify-between w-full items-baseline">
            <p class="text-4xl font-bold text-black">
                {{ convertDecimalHoursToHrsMins(+$$TimeDTO()[0].make_ready_time).hours }}
                <span class="text-lg">h</span>
                {{ convertDecimalHoursToHrsMins(+$$TimeDTO()[0].make_ready_time).minutes }}
                <span class="text-lg">mins</span>
            </p>
        </div>
        <p class="text-sm font-semibold">Make Ready Time</p>
        <div class="mt-auto w-full flex justify-between items-center pt-2">
            <p class="text-sm text-gray-500 font-medium">Make Ready Count</p>
            <span class="bg-blue-100 text-blue-700 text-sm font-semibold px-3 py-1 rounded-full">
                {{ $$ImpressionDTO()[0].makeReadyCount }}
            </span>
        </div>
    </div>

    <div class="bg-white rounded-lg shadow-lg w-full flex flex-col items-start p-4 h-32">
        <div class="flex justify-between w-full items-baseline">
            <p class="text-4xl font-bold text-black">
                {{ convertDecimalHoursToHrsMins(+$$TimeDTO()[0].operation_time).hours }}
                <span class="text-lg">h</span>
                {{ convertDecimalHoursToHrsMins(+$$TimeDTO()[0].operation_time).minutes }}
                <span class="text-lg">mins</span>
            </p>
        </div>
        <p class="text-sm font-semibold">Operational Time</p>
    </div>

    <div class="bg-white rounded-lg shadow-lg w-full flex flex-col items-start p-4 h-32">
        <div class="flex justify-between w-full items-baseline">
            <p class="text-4xl font-bold text-black">
                {{ convertDecimalHoursToHrsMins(+$$TimeDTO()[0].idle_time).hours }}
                <span class="text-lg">h</span>
                {{ convertDecimalHoursToHrsMins(+$$TimeDTO()[0].idle_time).minutes }}
                <span class="text-lg">mins</span>
            </p>
        </div>
        <p class="text-sm font-semibold">Machine Idle Time</p>
    </div>

    <div class="bg-white rounded-lg shadow-lg w-full flex flex-col items-start p-4 h-32">
        <div class="flex justify-between w-full items-baseline">
            <p class="text-4xl font-bold text-black">
                {{ convertDecimalHoursToHrsMins(+$$TimeDTO()[0].hold_time).hours }}
                <span class="text-lg">h</span>
                {{ convertDecimalHoursToHrsMins(+$$TimeDTO()[0].hold_time).minutes }}
                <span class="text-lg">mins</span>
            </p>
        </div>
        <p class="text-sm font-semibold">Machine Hold Time</p>
    </div>

    <div class="bg-white rounded-lg shadow-lg w-full flex flex-col items-start p-4 h-32">
        <div class="flex justify-between w-full items-baseline">
            <p class="text-4xl font-bold text-black">
                {{ convertDecimalHoursToHrsMins(+$$TimeDTO()[0].maintenance_time).hours }}
                <span class="text-lg">h</span>
                {{ convertDecimalHoursToHrsMins(+$$TimeDTO()[0].maintenance_time).minutes }}
                <span class="text-lg">mins</span>
            </p>
        </div>
        <p class="text-sm font-semibold">Machine Maintenance Time</p>
    </div>
</div>

<div class="mx-6 mt-4 bg-white rounded-lg shadow-lg">
  <h6 class="font-semibold text-gray-700 px-6 pt-4">Daily Production Operation Timeline {{ timelineHeaderStr() }}</h6>
  <apx-chart
    #chart
    [series]="chartOptions.series"
    [chart]="chartOptions.chart"
    [xaxis]="chartOptions.xaxis"
    [yaxis]="chartOptions.yaxis"
    [stroke]="chartOptions.stroke"
    [dataLabels]="chartOptions.dataLabels"
    [grid]="chartOptions.grid"
    [legend]="chartOptions.legend"
    [tooltip]="chartOptions.tooltip"
    [annotations]="chartOptions.annotations"
    [fill]="chartOptions.fill"
  ></apx-chart>
</div>
<!-- 
<div class="mx-6 mt-4 bg-white rounded-lg shadow-lg p-1 mb-4 pb-4">
    <div class="flex flex-col lg:flex-row gap-4 px-4 pt-4 lg:items-center">
        <div class="font-semibold text-base text-gray-800 text-center lg:text-left">
            <span *ngIf="selectedMachineName">{{ selectedMachineName }}</span>
            Machine Monthly Production Overview
        </div>
    </div>
</div> -->

<div class="mx-6 mt-4 bg-white rounded-lg shadow-lg p-1 mb-4 pb-4">
    <div class="flex flex-col lg:flex-row gap-4 px-4 pt-4 lg:items-center">
        <div class="font-semibold text-base text-gray-800 text-center lg:text-left">
            Select date range to get downtimes for the machine
        </div>

        <div class="flex flex-col sm:flex-row gap-3 sm:gap-4 w-full lg:w-auto lg:flex-nowrap ml-auto">
            <input
            type="date"
            [max]="today"
            class="textField flex-1 min-w-[150px]"
            [(ngModel)]="holdSearchParams().start_date"
            (ngModelChange)="onDateChangeHold('start_date', $event)"
            />

            <input
            type="date"
            [min]="holdSearchParams().start_date || ''"
            [max]="today"
            class="textField flex-1 min-w-[150px]"
            [(ngModel)]="holdSearchParams().end_date"
            (ngModelChange)="onDateChangeHold('end_date', $event)"
            />

            <button
            class="button-blue w-full sm:w-auto whitespace-nowrap"
            (click)="getHoldReasonsByMachine()"
            >
            Get Hold Times Details 
            </button>
        </div>
    </div>

    <div *ngIf="$$MachineHoldDataDTO().length > 0" class="px-4 pt-4 pb-1">
        <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-5">

            <div class="bg-blue-100 border border-blue-300 rounded-lg shadow-md p-5 sm:col-span-1 md:col-span-2" (click)="openHoldJobDetails()">
                <div class="text-center mb-3">
                    <div class="text-base font-semibold text-gray-800">Total Hold Reasons</div>
                </div>

                <div class="space-y-2">
                    <div *ngFor="let reason of getHoldReasonSummary()" class="flex justify-between text-sm items-center">
                    <div class="text-gray-700 truncate">• {{ reason.reason }}</div>
                    <div class="text-gray-900 font-medium">{{ convertToHoursAndMinutes(reason.time) }}</div>
                    </div>
                </div>

                <div class="border-t border-gray-400 mt-3 pt-2 flex justify-between font-semibold text-gray-800">
                    <div>Total Hold Time</div>
                    <div>{{ convertToHoursAndMinutes(getTotalHoldTime()) }}</div>
                </div>

                <!-- <div class="border-t border-gray-400 mt-2 pt-2 flex justify-between font-semibold text-gray-800">
                    <div>Total Idle Time</div>
                    <div>{{ convertToHoursAndMinutes(getTotalIdleTime()) }}</div>
                </div> -->

                <!-- <div class="border-t border-gray-400 mt-3 pt-2 flex justify-between font-semibold text-gray-800">
                    <div>Total Machine Downtime</div>
                    <div>{{ convertToHoursAndMinutes(getTotalMachineDowntime()) }}</div>
                </div> -->


            </div>

            <div 
                *ngFor="let day of $$MachineHoldDataDTO()[0].dailyHoldReasons" 
                class="bg-white border border-gray-100 rounded-lg shadow-md hover:shadow-lg transition-shadow flex flex-col p-5"
                >
                <div class="text-center mb-3">
                    <div class="text-sm text-gray-500 font-medium">Date</div>
                    <div class="text-base font-semibold text-gray-800">
                    {{ day.date | date:'EEE, MMM d, y' }}
                    </div>
                </div>
                <div class="flex-1 space-y-2 overflow-y-auto scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100">
                    <div 
                    *ngFor="let reason of day.reasons" 
                    class="flex justify-between text-sm items-center border-b border-dashed border-gray-200 pb-1"
                    >
                    <div class="text-gray-700 truncate w-2/3">{{ reason.reason }}</div>
                    <div class="text-gray-900 font-medium text-right w-1/3">{{ convertToHoursAndMinutes(reason.time) }}</div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>

@if(modal.$$holdJobDetails()){
    <div id="operation-modal" tabindex="-1" aria-hidden="true"
        class="fixed inset-0 z-50 flex justify-center items-center overflow-y-auto bg-gray-900 bg-opacity-50">
        <div class="relative p-4 w-full max-w-5xl mx-auto bg-white rounded-lg shadow-lg max-h-80vh overflow-y-auto">
            <div class="relative">
                <div class="flex items-center justify-between p-4 border-b rounded-t">
                <h3 class="text-lg font-semibold text-gray-900 flex items-center">
                    <span>Hold Job Details</span>
                    <span class="status-badge ml-4"></span>
                </h3>
                <button type="button" (click)="modal.$$holdJobDetails.set(false)"
                    class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 flex justify-center items-center"
                    data-modal-toggle="crud-modal">
                    <svg class="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"/>
                    </svg>
                    <span class="sr-only">Close modal</span>
                </button>
                </div>
                <div class="p-4 space-y-4 max-h-[80vh] overflow-y-auto scrollbar-hide">
                    <div *ngFor="let item of getHoldReasonSummary()" class="border-b pb-8 p-4">
                    <div class="flex justify-between items-center mb-2">
                        <span class="font-semibold text-gray-800 text-lg uppercase">{{ item.reason }}</span>
                        <span class="text-gray-600 text-sm">{{ convertToHoursAndMinutes(item.time) }}</span>
                    </div>

                    <ul class="pl-5 list-disc space-y-2 text-sm">
                        <li *ngFor="let job of item.jobs; let i = index" class="cursor-pointer">

                            <div 
                            (click)="toggleJob(item.reason + '-' + i)" 
                            class="flex items-center justify-between p-2 hover:bg-gray-100 rounded"
                            >
                            <div class="flex items-center gap-3 flex-1 min-w-0">
                                
                                <span class="font-semibold shrink-0">
                                {{ job.jobNo }}
                                </span>

                                <span class="truncate">
                                {{ job.customer }}
                                </span>
                            </div>

                            <div class="flex items-center gap-4 shrink-0">
                                <span class="text-sm font-semibold">
                                    {{ cleanOperators(job.operators) }}
                                </span>

                                <span class="text-gray-500 text-xs">
                                ({{ convertToHoursAndMinutes(job.time) }})
                                </span>
                            </div>
                            </div>

                            <div 
                            *ngIf="isJobExpanded(item.reason + '-' + i)" 
                            class="pl-4 mt-1 text-gray-700 text-sm bg-gray-50 p-2 rounded border-l-2 border-gray-300 flex flex-col gap-2"
                            >
                                <div>{{ job.jobDescription }}</div>
                                <div *ngIf="job.plateCount > 0">
                                    <span class="bg-blue-100 text-blue-800 text-xs font-semibold px-2.5 py-0.5 rounded border border-blue-200">
                                        Plates Changed: {{ job.plateCount }}
                                    </span>
                                </div>
                            </div>

                        </li>
                    </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
}